export const EVENT_PREVIEW_DATE_FORMAT = 'DD MMMM / HH:mm';
export const NEWS_DATE = 'DD MMMM YYYY';
export const ONLY_DATE_WITH_MONTH = 'DD MMMM';
export const ONLY_MONTH = 'MMMM';
export const ONLY_MONTH_WITH_YEAR = 'MMMM YYYY';
export const ONLY_DAY = 'DD';
export const ONLY_TIME = 'HH:mm';
export const MONTH_WITH_DAY = 'MMMM, DD';
